import Vue from 'vue'
import VueRouter from 'vue-router'
import routes from '@/router/routes'
import i18n from "@/i18n"

Vue.use(VueRouter)

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
})

// Navigations guards
router.beforeEach((to,from,next) => {

    const loggedIn = localStorage.getItem('logged')

    if (to.matched.some(record => record.meta.requiresAuth) && !loggedIn) {

        next('/')
       
    }

    next()

})

// Handle locale
router.beforeEach((to, from, next) => {

    let locale = to.params.locale

    if (!locale) {

        locale = 'es'

    }
  
    i18n.locale = locale

    next()
  
})

export default router
